import React, { Fragment, useContext, useEffect, useState } from "react";

import { post } from 'axios';
// Provider
import { AppContext } from "../../../../../components/AppProvider";

// Utils
import { _O } from "../../../../../modules/utils";

// UI
import { IC, Doctor } from "../../../../../resources/Assets";
import { Container, DateLayer, DateTimeLayer, openLayerFn, closeLayerFn, pickerStart } from "../../../../Layout";
import { DoctorMessage } from "../../../SM.Layers";
import { ScrollToTop } from "../../../../common/ScrollToTop/ScrollToTop";

// Temp Images
import _T_MEAL from "../../../../../resources/images/user/user_meal_photo01.jpg";
import {  PostApi1119 } from "../../../../../modules/network/padoPost";
import { SUBS, SubMenu } from "../../History";

export const MemoLayer = (props) => {
    const {seqNo, memo, reloadList, openAlertPopup} = props;
    const {userinfo, cfg, phonecfg} = useContext(AppContext);

    // const postApi119 = async (userinfo, cfg, seqNo, bpMemo) => {
    //     const url = cfg.url+'/pado/'+'119';
    //     const formData = new FormData();
    //     formData.append('userToken',  userinfo.userToken);
    //     formData.append('phoneToken', userinfo.phoneToken);
    //     formData.append('seqNo', seqNo);
    //     formData.append('bpcMemo', bpMemo);
        
    //     const config = {
    //         headers: {
    //             'content-type': 'multipart/form-data'
    //         }
    //     }
    
    //     const response = await post(url, formData, config);
    //     const body = await JSON.parse(JSON.stringify(response.data));
    
    //     return body;
    // }

    const request1119 = (userinfo, cfg, seqNo, bpMemo) => {
        PostApi1119(userinfo, cfg, phonecfg, seqNo, bpMemo)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                // openAlertPopup("저장되었습니다.");
                reloadList();
            } else {
                console.log("LOGOUT!!!");
            }
        })
        .catch(err => {
            console.log(err);
        });
    };

    return (
        <div className="blacklayer-container memo-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">메모</div>

                        <div className="inlayer-memo-area">
                            <textarea className="textarea-box" placeholder="메모를 입력해 주세요." id="memoPopupValue"/>
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a onClick={()=>request1119(userinfo, cfg, seqNo, $("#memoPopupValue").val())} className="btn-round wht">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};